import React from "react";
import { ICustomerSalesRatioList } from "../../../models/response/ITotallingManagementResponse";
import { observer } from "mobx-react";
import { FormattedMessage } from "react-intl";
import { formatMessage } from "../../../translations/format-message";
import { showAmountWithFormatting } from "../../../helpers/common-component-helper";

interface IProps {
  data: ICustomerSalesRatioList[];
}

const CustomerDailySalesAccToAgeGroup: React.FC<IProps> = ({ data }) => {
  return (
    <div className="table-responsive age-gender-table mb-4">
      <table className="table table-bordered table-hover align-middle text-sm">
        <thead className="text-center align-middle">
          <tr className="table-primary">
            <th rowSpan={2} className="align-middle">
              <FormattedMessage id="age_group" />
            </th>
            <th colSpan={2} className="border-start border-end bg-light">
              <FormattedMessage id="male" />
            </th>
            <th colSpan={2} className="border-start border-end bg-light">
              <FormattedMessage id="female" />
            </th>
            <th colSpan={2} className="border-start border-end bg-light">
              <FormattedMessage id="not_set" />
            </th>
          </tr>
          <tr className="table-secondary">
            <th className="border-start">
              <FormattedMessage id="number_of_people" />
            </th>
            <th className="border-end">
              <FormattedMessage id="average_customer_spending" />
            </th>
            <th className="border-start">
              <FormattedMessage id="number_of_people" />
            </th>
            <th className="border-end">
              <FormattedMessage id="average_customer_spending" />
            </th>
            <th className="border-start">
              <FormattedMessage id="number_of_people" />
            </th>
            <th className="border-end">
              <FormattedMessage id="average_customer_spending" />
            </th>
          </tr>
        </thead>
        <tbody className="text-center">
          {data && data.length > 0 ? (
            data.map((row, index) => (
              <tr key={index}>
                <td className="text-start fw-semibold">
                  {formatMessage(row.ColumnName)}
                </td>
                {/* male */}
                <td className="border-start">
                  {row.NumberOfPeopleMale} ({row.NumberOfPeopleMalePercentage}
                  %)
                </td>
                <td className="border-end">
                  {showAmountWithFormatting(row.AverageCustomerSpendingMale)}
                </td>
                {/* female */}
                <td className="border-start">
                  {row.NumberOfPeopleFemale} (
                  {row.NumberOfPeopleFemalePercentage}%)
                </td>
                <td className="border-end">
                  {showAmountWithFormatting(row.AverageCustomerSpendingFemale)}
                </td>
                {/* not set */}
                <td className="border-start">
                  {row.NumberOfPeopleNotSet} (
                  {row.NumberOfPeopleNotSetPercentage}%)
                </td>
                <td className="border-end">
                  {showAmountWithFormatting(row.AverageCustomerSpendingNotSet)}
                </td>
              </tr>
            ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center">
                  <FormattedMessage id="no_data_found" />
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
    </div>
  );
};

export default observer(CustomerDailySalesAccToAgeGroup);
